var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"type":"flex","align":"middle","justify":"center"}},[_c('span',{staticStyle:{"margin-right":"8px"}},[_vm._v(_vm._s(_vm.text))]),_c('el-button',{attrs:{"circle":"","size":"mini","icon":"el-icon-copy-document"},on:{"click":function($event){return _vm.handleCopy(_vm.text)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }